/*********
 Header Sticky
 **********/


/**************
 Mobile Nav
 ***************/

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("#slider").classList.add("active");
    document.querySelector('#sliderContent').classList.add('active');
    document.querySelector("body").classList.add("noScroll");
}

// close nav
function closeNav() {
    document.querySelector('#sliderContent').classList.remove('active');
    document.querySelector("#slider").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");

    // Wait before closing - allows animation to complete
    setTimeout(function () {
        document.querySelector("#slider").close();
    }, 400);
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));